import { Injectable, signal, effect } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {
  IOrder,
  IState,
  IParkerProfileData,
  IParkerProfileDetail,
  IAdditionalEmails,
  IAdditionalVehicles,
  ICompaniesShortList,
  ISpaceEmailUsers,
  IParkerProfileMassUpdate,
  IParkerMassUpdateCompany,
  IParkerMassUpdateRate,
  IStallTypes,
  ILotRateList,
  IParkerMassUpdateParkerPayType,
  IParkerMassUpdateInvoiceDeliveryMethod,
  IParkerProfileDetailForExport,
  ILotDisableSpace,
  IParkerMassUpdateTermDate,
  ILotUsageMetrics,
} from '../../../shared/interfaces';
import { UtilitiesService } from '../helper/utilities.service';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { ClonerService } from '../helper/cloner.service';
import { elections } from '@igniteui/material-icons-extended';
import { DataService } from '../data/data.service';
import { aceDates } from 'src/app/shared/helpers/transform/aceDates';

@Injectable({ providedIn: 'root' })
export class ParkerStateService {
  devLinkId: string = '';
  currentLinkId: string = '';
  devUserId: string = '';
  validatedUserId: string = '';
  parkerExpiredRates: IParkerProfileDetail[] = [];
  parkerDuplicateKeyCards: IParkerProfileDetail[] = [];
  additionalEmailList: IAdditionalEmails[];
  additionalVehicleList: IAdditionalVehicles[];
  spaceUsersForLotNumber: ISpaceEmailUsers[] = [];
  queryNumberOfParkerResults: number = 0;
  public parkerQueryResults: IParkerProfileDetail[] = [];
  public filteredParkers: IParkerProfileDetail[] = [];
  parkerProfileNoQuery: boolean = true;
  parkerEnableMode: boolean = false;
  modeAddNew: boolean = false;

  currentParkerFilter: string = 'ALL';
  queryCriteriaForm: FormGroup;
  companyList: ICompaniesShortList[] = [];
  pendingNewLotNumber: string = '';
  activeParkerId: string = '';
  private currentParkerDetail: IParkerProfileDetail;
  parkerQueryPerformed: boolean = false;
  public parkerNumberAdditionalEmails: number = 0;
  public parkerNumberAdditionalVehicles: number = 0;
  private removeParkerProfileQueryResults: boolean = false;
  public parkerIsSelected: string[] = [];
  public parkerUpdateList: IParkerProfileMassUpdate[] = [];
  public allParkersSelectedForMassUpdate: boolean = false;
  public stallDescriptions: IStallTypes[] = [];
  public marketRateList: ILotRateList[] = [];
  public massUpdateResultsExist: boolean = false;
  public lastMassUpdateDateTime: Date;
  public gridExportData: IParkerProfileDetailForExport[] = [];
  public spaceDisableLotList: ILotDisableSpace[] = [];
  public lotRateUsageMetrics: ILotUsageMetrics[] = [];
  public isEditModeEnabled: boolean = false;
  public currentParkerIdInEditMode: string = undefined;
  public testVar: string = 'got it';

  // Signals
  public currentParkerId = signal('');

  constructor(
    private http: HttpClient,
    private clonerService: ClonerService,
    private dataService: DataService,
  ) {}

  get ParkerIdValue() {
    return this.currentParkerId.asReadonly(); // Expose a read-only signal.
  }

  onCloneParkerUpdateList(): void {
    this.filteredParkers = this.clonerService.deepClone(this.filteredParkers);
  }

  public updateParkerQueryData(parkerDetailProfile: IParkerProfileDetail): void {
    const indexFilteredParkers = this.filteredParkers.findIndex(
      (data) => data.parkerId == parkerDetailProfile.parkerId,
    );
    const indexParkerQueryResults = this.parkerQueryResults.findIndex(
      (data) => data.parkerId == parkerDetailProfile.parkerId,
    );

    if (indexFilteredParkers !== -1) {
      this.filteredParkers[indexFilteredParkers] = parkerDetailProfile;
    }

    if (indexParkerQueryResults !== -1) {
      this.parkerQueryResults[indexParkerQueryResults] = parkerDetailProfile;
    }
  }

  areAllParkersSelectedForUpdate(): boolean {
    let allSelected: boolean = true;

    allSelected = this.filteredParkers.length === this.parkerUpdateList.length;

    return allSelected;
  }

  GetLotRateUsageMetrics(lotNumber: string) {
    this.dataService.GetLotMarketCompanyUsageMetrics(lotNumber).subscribe(
      (res) => {
        this.lotRateUsageMetrics = res;
      },
      (err: any) => {},
      () => {},
    );
  }

  public resetQueryData(): void {
    this.parkerExpiredRates = [];
    this.parkerDuplicateKeyCards = [];
    this.parkerQueryResults = [];
    this.filteredParkers = [];
    this.parkerQueryPerformed = false;
    //this.currentLotDisplayName = ''; MARKED FOR DELETION 20241114 :: Ken Moss
    this.parkerEnableMode = false;
  }

  GetSpaceDisableSetting(lotNumber: string): boolean {
    let spaceDisableSetting: boolean = false;
    let ii: number;

    for (ii = 0; ii < this.spaceDisableLotList.length; ii++) {
      if (lotNumber == this.spaceDisableLotList[ii].lotNumber) {
        spaceDisableSetting = this.spaceDisableLotList[ii].spaceDisable;
        break;
      }
    }

    return spaceDisableSetting;
  }

  setEnableModeOn(): void {
    this.parkerEnableMode = true;
  }

  setRemoveParkerProfileQueryResults(status: boolean): void {
    this.removeParkerProfileQueryResults = status;
  }

  getRemoveParkerProfileQueryResults(): boolean {
    return this.removeParkerProfileQueryResults;
  }

  setCurrentLinkId(linkId: string): void {
    this.currentLinkId = linkId;
  }

  getCurrentLinkId(): string {
    return this.currentLinkId;
  }

  getDevLinkId(): string {
    return this.devLinkId;
  }

  getDevUserId(): string {
    return this.devUserId;
  }

  setValidatedUserId(userId: string): void {
    this.validatedUserId = userId;
  }

  getValidatedUserId(): string {
    return this.validatedUserId;
  }

  getQuickSearchRoutingId(): string {
    return '1';
  }

  getProfileRoutingId(): string {
    return '2';
  }

  getUtilityRoutingId(): string {
    return '3';
  }

  setParkerDetail(parkerData: IParkerProfileDetail): void {
    this.currentParkerDetail = parkerData;
  }

  getParkerDetail(): IParkerProfileDetail {
    return this.currentParkerDetail;
  }

  setFilteredParkerData(filteredParkers: IParkerProfileDetail[]): void {
    this.filteredParkers = filteredParkers;
  }

  setParkerQueryResults(parkerQueryResults: IParkerProfileDetail[]): void {
    this.parkerQueryResults = parkerQueryResults;
  }

  getFilteredParkerData(): IParkerProfileDetail[] {
    return this.filteredParkers;
  }

  getParkerQueryResults(): IParkerProfileDetail[] {
    return this.parkerQueryResults;
  }

  setAdditionalEmailData(additionalEmails: IAdditionalEmails[]): void {
    this.additionalEmailList = additionalEmails;
  }

  getAdditionalEmailData(): IAdditionalEmails[] {
    return this.additionalEmailList;
  }

  setAdditionalVehicleData(additionalEmails: IAdditionalVehicles[]): void {
    this.additionalVehicleList = additionalEmails;
  }

  getAdditionalVehicleData(): IAdditionalVehicles[] {
    return this.additionalVehicleList;
  }

  getTestData(): string {
    return 'Test Data';
  }

  updateFilteredParkers(updatedParker: IParkerProfileDetail) {
    let ii: number = 0;

    for (ii = 0; ii < this.parkerQueryResults.length; ii++) {
      if (this.parkerQueryResults[ii].parkerId === updatedParker.parkerId) this.parkerQueryResults[ii] = updatedParker;
    }

    for (ii = 0; ii < this.filteredParkers.length; ii++) {
      if (this.filteredParkers[ii].parkerId === updatedParker.parkerId) this.filteredParkers[ii] = updatedParker;
    }
  }

  updateParkerTermDateDataAfterMassUpdate(termDateUpdate: IParkerMassUpdateTermDate[]): void {
    let ii: number;
    let jj: number;
    let dateUtils: aceDates = new aceDates();

    for (ii = 0; ii < termDateUpdate.length; ii++) {
      const allParkerIndex = this.parkerQueryResults.findIndex((x) => x.parkerId === termDateUpdate[ii].parkerId);
      const filteredParkersIndex = this.filteredParkers.findIndex((x) => x.parkerId === termDateUpdate[ii].parkerId);

      //calling dateUtils.getDateOnly removes time portion of Date
      const today: Date = dateUtils.getDateOnly(new Date());
      const updateDate: Date = dateUtils.getDateOnly(new Date(termDateUpdate[0].termDate));

      // Set the value for the Active column on DB
      let activeUpdateText: string;
      activeUpdateText = 'A';

      if (updateDate.getTime() < today.getTime()) {
        activeUpdateText = 'I';
      }

      if (allParkerIndex != -1) {
        this.parkerQueryResults[allParkerIndex].endDate = termDateUpdate[ii].termDate;
        this.parkerQueryResults[allParkerIndex].active = activeUpdateText;
      }

      if (filteredParkersIndex != -1) {
        this.filteredParkers[filteredParkersIndex].endDate = termDateUpdate[ii].termDate;
        this.filteredParkers[filteredParkersIndex].active = activeUpdateText;
      }

      for (jj = 0; jj < this.parkerUpdateList.length; jj++) {
        this.parkerUpdateList[jj].endDate = termDateUpdate[ii].termDate;
      }
    }
  }

  updateParkerInvoiceDeliveryMethodDataAfterMassUpdate(rateUpdateData: IParkerMassUpdateInvoiceDeliveryMethod[]): void {
    let ii: number;
    let jj: number;

    for (ii = 0; ii < rateUpdateData.length; ii++) {
      const allParkerIndex = this.parkerQueryResults.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);
      const filteredParkersIndex = this.filteredParkers.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);

      if (allParkerIndex != -1) {
        this.parkerQueryResults[allParkerIndex].deliveryType = rateUpdateData[ii].invoiceDeliveryMethod;
      }

      if (filteredParkersIndex != -1) {
        this.filteredParkers[filteredParkersIndex].deliveryType = rateUpdateData[ii].invoiceDeliveryMethod;
      }

      for (jj = 0; jj < this.parkerUpdateList.length; jj++) {
        this.parkerUpdateList[jj].invoiceDeliveryMethod = rateUpdateData[ii].invoiceDeliveryMethod;
      }
    }
  }

  updateParkerPayTypeDataAfterMassUpdate(rateUpdateData: IParkerMassUpdateParkerPayType[]): void {
    let ii: number;
    let jj: number;

    for (ii = 0; ii < rateUpdateData.length; ii++) {
      const allParkerIndex = this.parkerQueryResults.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);
      const filteredParkersIndex = this.filteredParkers.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);

      if (allParkerIndex != -1) {
        this.parkerQueryResults[allParkerIndex].parkerPayType = rateUpdateData[ii].parkerPayType;
      }

      if (filteredParkersIndex != -1) {
        this.filteredParkers[filteredParkersIndex].parkerPayType = rateUpdateData[ii].parkerPayType;
      }

      for (jj = 0; jj < this.parkerUpdateList.length; jj++) {
        this.parkerUpdateList[jj].parkerPayType = rateUpdateData[ii].parkerPayType;
      }
    }
  }

  updateParkerRateDataAfterMassUpdate(rateUpdateData: IParkerMassUpdateRate[]): void {
    let ii: number;
    let jj: number;

    for (ii = 0; ii < rateUpdateData.length; ii++) {
      const allParkerIndex = this.parkerQueryResults.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);
      const filteredParkersIndex = this.filteredParkers.findIndex((x) => x.parkerId === rateUpdateData[ii].parkerId);

      const newStallName = this.getStallNameByRateNumber(rateUpdateData[ii].newRateNumber);
      const newRateNumber = rateUpdateData[ii].newRateNumber;
      const newRateDescription = this.getRateDescription(rateUpdateData[ii].newRateNumber);
      const newRateAmount = this.getRateAmount(rateUpdateData[ii].newRateNumber);

      if (allParkerIndex != -1) {
        this.parkerQueryResults[allParkerIndex].rateNumber = newRateNumber;
        this.parkerQueryResults[allParkerIndex].stallType = newStallName;
        this.parkerQueryResults[allParkerIndex].rateDescription = newRateDescription;
        this.parkerQueryResults[allParkerIndex].rate = newRateAmount;
      }

      if (filteredParkersIndex != -1) {
        this.filteredParkers[filteredParkersIndex].rateNumber = newRateNumber;
        this.filteredParkers[filteredParkersIndex].stallType = newStallName;
        this.filteredParkers[filteredParkersIndex].rateDescription = newRateDescription;
        this.filteredParkers[filteredParkersIndex].rate = newRateAmount;
      }

      for (jj = 0; jj < this.parkerUpdateList.length; jj++) {
        this.parkerUpdateList[jj].rate = newRateAmount;
      }
    }
  }

  updateParkerCompanyDataAfterMassUpdate(companyUpdateData: IParkerMassUpdateCompany[]): void {
    let ii: number;
    let jj: number;

    for (ii = 0; ii < companyUpdateData.length; ii++) {
      //update
      const allParkerIndex = this.parkerQueryResults.findIndex((x) => x.parkerId === companyUpdateData[ii].parkerId);
      const filteredParkersIndex = this.filteredParkers.findIndex((x) => x.parkerId === companyUpdateData[ii].parkerId);
      const newCompanyName = this.getCompanyNameByCompanyId(companyUpdateData[ii].newCompanyId);

      if (allParkerIndex != -1) {
        this.parkerQueryResults[allParkerIndex].companyId = companyUpdateData[ii].newCompanyId;
        this.parkerQueryResults[allParkerIndex].companyName = newCompanyName;
      }

      if (filteredParkersIndex != -1) {
        this.filteredParkers[filteredParkersIndex].companyId = companyUpdateData[ii].newCompanyId;
        this.filteredParkers[filteredParkersIndex].companyName = newCompanyName;
      }

      for (jj = 0; jj < this.parkerUpdateList.length; jj++) {
        this.parkerUpdateList[jj].companyName = newCompanyName;
      }
    }
  }

  getRateDescription(rateNumber: number): string {
    let rateDescription: any = this.stallDescriptions.find((x) => x.rateNumber == rateNumber)?.parkingStallType;

    return rateDescription;
  }

  getRateAmount(rateNumber: number): number {
    let rateAmount: any = this.marketRateList.find((x) => x.rateNumber == rateNumber)?.displayRate;

    return rateAmount;
  }

  getStallNameByRateNumber(rateNumber: number): string {
    let description: any = this.stallDescriptions.find((x) => x.rateNumber == rateNumber)?.parkingStallType;

    return description;
  }

  getCompanyNameByCompanyId(companyIdToFind: string): string {
    let companyName: any = this.companyList.find((x) => x.companyId == companyIdToFind)?.companyName;

    return companyName;
  }

  sortParkerProfileData(sort: Sort) {
    let tempSort: IParkerProfileDetail[] = [];
    if (this.filteredParkers === null) return;
    const data = this.filteredParkers.slice();
    if (!sort.active || sort.direction === '') {
      this.filteredParkers = data;
      return;
    }

    tempSort = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';

      switch (sort.active) {
        case 'active':
          return this.compare(a.active, b.active, isAsc);
        case 'cardNo':
          return this.compare(a.cardNumber, b.cardNumber, isAsc);
        case 'stallType':
          return this.compare(a.stallType, b.stallType, isAsc);
        case 'company':
          return this.compare(a.companyName, b.companyName, isAsc);
        case 'name':
          return this.compare(a.lastName, b.lastName, isAsc);
        case 'lastName':
          return this.compare(a.lastName, b.lastName, isAsc);
        case 'firstName':
          return this.compare(a.firstName, b.firstName, isAsc);
        case 'email':
          return this.compare(a.emailAddress, b.emailAddress, isAsc);
        case 'additionalEmails':
          return this.compare(a.additionalEmails, b.additionalEmails, isAsc);
        case 'startDate':
          return this.compareDates(a.startDate, b.startDate, isAsc);
        case 'endDate':
          return this.compareDates(a.endDate, b.endDate, isAsc);
        case 'rate':
          return this.compare(a.rate, b.rate, isAsc);
        case 'taxExempt':
          return this.compare(a.taxExempt, b.taxExempt, isAsc);
        case 'payment':
          return this.compare(a.parkerPayType, b.parkerPayType, isAsc);
        case 'delivery':
          return this.compare(a.deliveryType, b.deliveryType, isAsc);
        case 'space':
          return this.compare(a.isAcePortal, b.isAcePortal, isAsc);
        case 'address':
          return this.compare(a.city, b.city, isAsc);
        case 'vehicle':
          return this.compare(a.vehicleLicense, b.vehicleLicense, isAsc);
        case 'comments':
          return this.compare(a.comments, b.comments, isAsc);
        case 'stallNumber':
          return this.compare(a.stallNumber, b.stallNumber, isAsc);
        default:
          return 0;
      }
    });

    this.filteredParkers = tempSort;
  }

  compareDates(a: Date, b: Date, isAsc: boolean) {
    // nulls sort after anything else
    let newA = new Date(a);
    let newB = new Date(b);

    if (isAsc) {
      if (newA === null) {
        return 1;
      }

      if (newB === null) {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? -1 : 1;
    } else {
      if (newA === null) {
        return 1;
      }

      if (newB === null) {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? 1 : -1;
    }
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    // nulls sort after anything else

    if (isAsc) {
      if (a === null) {
        return 1;
      }

      if (a === '') {
        return 1;
      }

      if (b === null) {
        return -1;
      }

      if (b === '') {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? -1 : 1;
    } else {
      if (a === null) {
        return 1;
      }

      if (a === '') {
        return 1;
      }

      if (b === null) {
        return -1;
      }

      if (b === '') {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? 1 : -1;
    }
  }
}
